<template>
  <Teleport to="body">
    <div class="modal-overlay" @mousedown.self="handleCancel">
      <dialog class="card modal-content">
        <div class="modal-header">
          <h3 class="modal-title">Создание путевого листа</h3>
          <button
            class="close-btn"
            type="button"
            @click="handleCancel"
          >
            ✕
          </button>
        </div>

        <base-loader v-if="dataIsLoading" />

        <form
          :id="formId"
          @submit.prevent="handleSubmit"
          class="waybill-form"
          v-else
        >
          <div class="form-body custom-scroll" ref="formBodyRef">
            <div class="form-group">
              <NumeratorField
                v-model="formData.number"
                input-id="number"
                target-model="Waybill"
              />
            </div>

            <div class="form-group">
              <base-label for="issued_on">Дата выдачи</base-label>
              <base-input
                id="issued_on"
                v-model="formData.issued_on"
                type="date"
              />
            </div>

            <requisite-create
              ref="requisiteCreateRef"
              :allowed-models="['Waybill']"
              :requisitable-type="'Waybill'"
              :form-id="formId"
            />
          </div>

          <div class="form-actions sticky-footer">
            <base-primary-button
              class="form-btn"
              type="submit"
              :form="formId"
              :disabled="isSubmitting"
            >
              <span v-if="isSubmitting">Сохранение...</span>
              <span v-else>Сохранить</span>
            </base-primary-button>

            <base-button
              class="form-btn"
              type="button"
              @click="handleCancel"
              :disabled="isSubmitting"
            >
              Отмена
            </base-button>
          </div>
        </form>
      </dialog>
    </div>
  </Teleport>
</template>

<script>
import { getCompanyId } from "@/utils/userUtils";
import { useNotificationStore } from "@/stores/notificationStore";
import { useWaybillStore } from "@/stores/waybillStore";

import waybillsApi from "@/services/api/waybillsApi";

import RequisiteCreate from "@/components/Requisite/RequisiteCreate.vue";
import NumeratorField from "@/components/Numerator/Field.vue";

export default {
  name: "WaybillForm",

  components: {
    NumeratorField,
    RequisiteCreate,
  },

  emits: ["close", "waybill-created"],

  data() {
    return {
      dataIsLoading: false,
      isSubmitting: false,
      formId: "waybill-create-form",
      companyId: getCompanyId(),
      formData: {
        number: "",
        issued_on: "",
      },
    };
  },

  computed: {
    notificationStore() {
      return useNotificationStore();
    },

    waybillStore() {
      return useWaybillStore();
    },
  },

  methods: {
    async handleSubmit() {
      try {
        this.isSubmitting = true;

        const response = await waybillsApi.create(this.companyId, {
          number: this.formData.number || undefined,
          issued_on: this.formData.issued_on || undefined,
        });
        const newWaybill = response.data.result;

        if (this.$refs.requisiteCreateRef) {
          await this.$refs.requisiteCreateRef.createRequisites(
            newWaybill.id
          );
        }

        this.notificationStore.showSuccess("Путевой лист создан");
        await this.waybillStore.fetchWaybills();
        this.$emit("waybill-created", newWaybill);
        this.$emit("close");
      } catch (error) {
        console.error("Ошибка при создании путевого листа", error);
      } finally {
        this.isSubmitting = false;
      }
    },

    handleCancel() {
      this.$emit("close");
    },
  },
};
</script>

<style scoped>
.modal-content {
  display: flex;
  flex-direction: column;
  overflow: hidden;
  padding: 0;
}

.modal-header {
  padding: 20px;
  border-bottom: 1px solid var(--color-grey);
  display: flex;
  justify-content: space-between;
  align-items: center;
  background: #fff;
  flex-shrink: 0;
}

.modal-title {
  margin: 0;
}

.close-btn {
  background: none;
  border: none;
  font-size: 24px;
  cursor: pointer;
  color: #999;
  transition: color 0.2s;
  width: 32px;
  height: 32px;
  display: flex;
  align-items: center;
  justify-content: center;
  border-radius: 4px;
}

.close-btn:hover {
  color: var(--color-dark);
  background: #f5f5f5;
}

.waybill-form {
  display: flex;
  flex-direction: column;
  flex: 1;
  overflow: hidden;
}

.form-body {
  flex: 1;
  overflow-y: auto;
  padding: 20px;
}

.custom-scroll::-webkit-scrollbar {
  width: 6px;
}

.custom-scroll::-webkit-scrollbar-thumb {
  background: #ddd;
  border-radius: 3px;
}

.custom-scroll::-webkit-scrollbar-thumb:hover {
  background: #bbb;
}

.sticky-footer {
  padding: 20px;
  border-top: 1px solid var(--color-grey);
  background: #fff;
  display: flex;
  justify-content: flex-start;
  gap: 15px;
  flex-shrink: 0;
  box-shadow: 0 -2px 10px rgba(0, 0, 0, 0.05);
}

@media screen and (max-width: 767px) {
  .sticky-footer {
    gap: 10px;
  }

  .sticky-footer button {
    flex: 1;
  }
}
</style>
